import { doc, getFirestore, setDoc } from "firebase/firestore";
import { DateTime } from "luxon";
import { MedicalPaperRequest, MedicalPaperRequestStatus } from "../types/MedicalPaperRequest";

export const updateMedicalPaperRequestStatus = async (medicalPaperRequest: MedicalPaperRequest, status: MedicalPaperRequestStatus) => {
  const db = getFirestore();

  let updateFields: any = { status };
  // if (status === 'Completed') {
  //   updateFields = {
  //     ...updateFields,
  //     dateCompleted: DateTime.utc().toISO(),
  //   }
  // }

  await setDoc(
    doc(db, `Employees/${medicalPaperRequest.idNumber}/MedicalPaperRequests/${medicalPaperRequest.id}`),
    updateFields,
    { merge: true }
  );
};
